import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PrincipalInvestigator from './pages/PrincipalInvestigator';
import Research from './pages/Research';
import Members from './pages/Members';
import Publication from './pages/Publication';
import NewsActivities from './pages/NewsActivities';
import Funding from './pages/Funding';
import SupportUs from './pages/SupportUs';
import Patents from './pages/Patent';  
import Conference from './pages/Conference';
import Contact from './pages/Contact';
import Alumni from './pages/Alumni';
import './App.css';
import ResearchDetail from './pages/Researchdetail';

function App() {
  return (
    <Router>
      <Header />
      <main style={{ minHeight: "70vh", margin: "0 auto", maxWidth: "1150px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/principal-investigator" element={<PrincipalInvestigator />} />
          <Route path="/research" element={<Research />} />
          <Route path="/members" element={<Members />} />
          <Route path="/alumni" element={< Alumni />} />
          <Route path="/publication" element={<Publication />} />
          <Route path="/patents" element={<Patents />} />
          <Route path="/conference" element={<Conference />} />
          <Route path="/news-activities" element={<NewsActivities />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/funding" element={<Funding />} />
          {/* <Route path="/supportus" element={<SupportUs />} /> */}
          <Route path="/research/:categoryId/:projectId" element={<ResearchDetail />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;